import uuid from 'uuid/v1';
import { getNewConversionsFromSessionStorage } from 'modules/codeless-events/utils/codelessSessionStorageUtils';
import { CODELESS_CONVERSION_TYPE_OPTIONS } from '../codelessConversionTypeOptions';

export const generateEmptyContentItem = options => ({
    id: uuid(),
    conversionType: CODELESS_CONVERSION_TYPE_OPTIONS.BUTTON_CLICKS,
    category: '',
    includeInTotalConversions: false,
    eventName: '',
    isActive: true,
    touched: true,
    urlEvent: '',
    conversionName: '',
    valueSelector: undefined,
    ...options,
});

export const codelessInitialValues = {
    newConversion: getNewConversionsFromSessionStorage(),
};
